import React from 'react';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import './MyPortfolioCapsuleSettings.scss';
import { useReferredState } from '@instinet-analytics/core-lib';
import cloneDeep from 'lodash/cloneDeep';

interface MyPortfolioCapsuleSettingsProps<TConfig> {
    strategy: MyPortfolioCapsuleWidgetStrategyWithConfig<TConfig>;
    config: TConfig;
    dispatchConfigChanged: (configDelta: Partial<TConfig>) => void;
}

/*
 * Capsule type specific settings in a Portfolio Capsule widget
 */
export function MyPortfolioCapsuleSettings<TConfig>(
    props: MyPortfolioCapsuleSettingsProps<TConfig>
) {
    const { strategy, config, dispatchConfigChanged } = props;

    const { renderSettingsBody } = strategy;

    const [, configRef, setConfigRef] = useReferredState<TConfig>(config);

    const onChange = (configDelta: Partial<TConfig>) => {
        const nextConfigRef = { ...configRef.current, ...configDelta };
        setConfigRef(nextConfigRef);
        dispatchConfigChanged(configDelta);
    };

    const capsuleConfig = {
        ...cloneDeep(strategy.initialConfigState),
        ...configRef.current,
    };

    return (
        <div className="MyPortfolioCapsuleSettings">
            {renderSettingsBody(capsuleConfig, onChange)}
        </div>
    );
}
